import { render, staticRenderFns } from "./order-mode.vue?vue&type=template&id=5d94ea39&scoped=true&"
import script from "./order-mode.vue?vue&type=script&lang=js&"
export * from "./order-mode.vue?vue&type=script&lang=js&"
import style0 from "./order-mode.sass?vue&type=style&index=0&id=5d94ea39&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d94ea39",
  null
  
)

export default component.exports